import React, { useContext } from "react"
import LanguageContext from '../../Utiliz/LanguageContext';


const TipsModal = ({ show, imageSrc, onClose, tipsContent, activeButton }) => {
  const { language } = useContext(LanguageContext)
  if (!show) return null;

  return (
    <div className="modal-overlay tips-modal">
      <div className="modal-content">
        <span className="close-button" onClick={() => {
          onClose()
        }}
        >&times;</span>
        <img className="position-relative" src={imageSrc} alt="Tips" width={'500px'} />
        {/* <p className="position-absolute tips-text">{language === 'en' ? 'TIPS' : '팁'}</p> */}
        <ol className={`position-absolute ${activeButton === 'basicmode' ? 'basicmode-tips' : 'areaselectionmode-tips'}`}>
          {tipsContent[language].map((tip, index) => (
            <li key={index}>{tip}</li>
          ))}
        </ol>
      </div>
    </div >
  )
}
export default TipsModal